export default "__VITE_ASSET__f0e0b96f__"